import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from '@/components/button';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  onPress: () => void;
  trackingData: TrackingData;
}

export const OrderInvoicePDFButton: React.FC<Props> = ({
  containerStyle,
  onPress,
  trackingData,
}) => {
  return (
    <Button
      containerStyle={containerStyle}
      leftElementStyle={styles.icon}
      onPress={onPress}
      trackingData={trackingData}
      type="secondary"
    >
      {i18n.t('view_invoice_pdf')}
    </Button>
  );
};

const styles = StyleSheet.create({
  icon: {
    marginRight: 8,
  },
});
